
(function () {
  // === Kurallar ===
  const discountedLinks = [];              // %20
  const noDiscountLinks = [];              // %0
  const additionalDiscountLinks = [        // %30
"/products/copy-of-14k-gold-diamond-solitaire-on-a-bail","/products/copy-of-14k-gold-prong-setting-diamond-solitaire-necklace","/products/copy-of-14k-gold-bezel-set-diamond-solitaire-necklace","/products/14k-bezel-setting-diamonds-studs-pair",
"/products/14k-prong-setting-round-diamond-studs","/products/14k-prong-setting-round-diamond-studs","/products/14k-prong-setting-round-diamond-studs","/products/14k-prong-setting-round-diamond-studs","/products/diamond-bracelet-diamond-solitaire-1",
"/products/14k-diamond-solitaire-necklace-on-a-bail","/products/14k-gold-bezel-setting-diamond-solitaire-bracelet-0-05ctw","/products/14k-prong-setting-diamond-solitaire-necklace","/products/diamond-solitaire-necklace14k-gold-007"

  ];

  function tokenOk() {
    if (location.href.includes('/collections/all?token=TF5WS78')) return true;
    try {
      const cookies = document.cookie.split('; ');
      for (const c of cookies) {
        const [k, v] = c.split('=');
        if (k && k.startsWith('_la_dn') && v) {
          const parsed = JSON.parse(decodeURIComponent(v));
          if (parsed?.Tokens?.includes('SDF7S5FB8TA3X')) return true;
        }
      }
    } catch(_) {}
    return true; // istersen false yap; token şart değilse true kalsın
  }

  function getRate(href) {
    if (noDiscountLinks.some(x => href.includes(x))) return 0;
    if (discountedLinks.some(x => href.includes(x))) return 0.20;
      if (href.includes('solitaire')) return 0.25;
    if (additionalDiscountLinks.some(x => href.includes(x))) return 0.30;
    if (location.pathname.includes('/collections/lab-grown-diamond') || href.includes('lab-grown')) return 0.30;
    if (location.pathname.includes('/collections/solitaire-collection')) return 0.25;
    if (location.pathname.startsWith('/collections/') && !location.pathname.includes('/collections/shipping')) return 0.20;
    return 0;
  }

  function parseCents(text){
    if (!text) return null;
    const cleaned = String(text).replace(/[^\d.,]/g,'').replace(/\s+/g,'');
    const normalized = cleaned.replace(/(\d)[.,](?=\d{3}\b)/g,'$1').replace(',', '.');
    const v = parseFloat(normalized);
    return isNaN(v) ? null : Math.round(v*100);
  }
  function fmt(c){
    if (window.Shopify?.formatMoney) {
      const f = (window.theme && theme.moneyFormat) || "${{amount}}";
      return Shopify.formatMoney(c, f);
    }
    return "$" + (c/100).toFixed(2);
  }

  // ——— Watcher (brute-force, timing-proof) ———
  let lastHiddenText = null;
  let lastAppliedCents = null;

  function applyIfPossible() {
    const priceBox = document.querySelector('.product-price-and-sku .product__price.limoniapps-discountninja-productprice[data-price-wrapper]');
    const hiddenOriginal = document.querySelector('.limoniapps-discountninja-productprice-original [data-product-price]');
    if (!priceBox || !hiddenOriginal) return;

    const hiddenText = hiddenOriginal.textContent || '';
    const originalCents = parseCents(hiddenText);
    const replaced = priceBox.querySelector('.limoniapps-discountninja-productprice-replaced');

    // Oran
    const rate = tokenOk() ? getRate(location.pathname) : 0;
    if (originalCents == null || !replaced) return;

    // Her değişimde birkaç kere üst üste deneyeceğiz (DN bazen 100–300ms gecikmeli renderlıyor)
    if (hiddenText !== lastHiddenText || originalCents !== lastAppliedCents) {
      // indirimli ve orijinal yaz
      const discountedCents = Math.max(0, Math.round(originalCents * (1 - rate)));

      const discText =
        replaced.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money .money') ||
        replaced.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money');
      if (discText) discText.textContent = fmt(rate ? discountedCents : originalCents);

      const origText =
        replaced.querySelector('.limoniapps-discountninja-shortcode-original_price .money .money') ||
        replaced.querySelector('.limoniapps-discountninja-shortcode-original_price .money');
      if (origText) origText.textContent = fmt(originalCents);

      // data-* cent senkronu
      replaced.querySelectorAll('.limoniapps-discountninja-shortcode-discounted_price .limoniapps-discountninja-money')
        .forEach(n => {
          const cents = rate ? discountedCents : originalCents;
          n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(cents));
          n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(cents));
          n.setAttribute('data-geolizr-price', String(cents));
          n.setAttribute('doubly-currency-usd', String(cents));
        });
      replaced.querySelectorAll('.limoniapps-discountninja-shortcode-original_price .limoniapps-discountninja-money')
        .forEach(n => {
          n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(originalCents));
          n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(originalCents));
          n.setAttribute('data-geolizr-price', String(originalCents));
          n.setAttribute('doubly-currency-usd', String(originalCents));
        });

      // küçük dürtme (DN/observer’lar)
      priceBox.setAttribute('data-dn-tick', Date.now());

      // yine de gecikme olabilir; 3 ek atış planla
      [80, 220, 600].forEach(delay => setTimeout(() => {
        const rep2 = document.querySelector('.product-price-and-sku .product__price.limoniapps-discountninja-productprice [class*="productprice-replaced"]');
        if (!rep2) return;
        const discText2 =
          rep2.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money .money') ||
          rep2.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money');
        if (discText2) discText2.textContent = fmt(rate ? discountedCents : originalCents);

        const origText2 =
          rep2.querySelector('.limoniapps-discountninja-shortcode-original_price .money .money') ||
          rep2.querySelector('.limoniapps-discountninja-shortcode-original_price .money');
        if (origText2) origText2.textContent = fmt(originalCents);

        rep2.querySelectorAll('.limoniapps-discountninja-shortcode-discounted_price .limoniapps-discountninja-money')
          .forEach(n => {
            const cents = rate ? discountedCents : originalCents;
            n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(cents));
            n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(cents));
            n.setAttribute('data-geolizr-price', String(cents));
            n.setAttribute('doubly-currency-usd', String(cents));
          });
        rep2.querySelectorAll('.limoniapps-discountninja-shortcode-original_price .limoniapps-discountninja-money')
          .forEach(n => {
            n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(originalCents));
            n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(originalCents));
            n.setAttribute('data-geolizr-price', String(originalCents));
            n.setAttribute('doubly-currency-usd', String(originalCents));
          });

        priceBox.setAttribute('data-dn-tick', Date.now());
      }, delay));

      lastHiddenText = hiddenText;
      lastAppliedCents = originalCents;
    }
  }

  // 1) Sürekli hafif “heartbeat”: 300ms’de bir kontrol (çok hafif CPU; yalnızca ürün sayfasında)
  const heartbeat = setInterval(applyIfPossible, 300);

  // 2) Sayfa görünürlüğü kapanınca durdur (sekme gizlenince yük binmesin)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearInterval(heartbeat);
  });

  // 3) İlk tetik
  applyIfPossible();
})();
